var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search",style:({'top': _vm.top})},[_c('input',{staticClass:"ant-input",style:({'width': _vm.width}),attrs:{"type":"text","id":"search-address","placeholder":_vm.$t('global.qsrdz')}})])}
var staticRenderFns = []

export { render, staticRenderFns }